import { render, staticRenderFns } from "./FilterSummaryItemSingle.vue?vue&type=template&id=57028cb8&"
import script from "./FilterSummaryItemSingle.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItemSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports